import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { getUserTcPreference, setRequestedPath } from 'utils/userPreferences';
import AppLayout from 'components/core/AppLayout';
import TermsAndConditions from 'components/pages/TermsAndConditions';

const PrivateRoutesWrapper = (props) => {
  const { isAuthenticated, hasAcceptedTC, userId, checkLogin, children } =
    props;
  const { pathname, search = '' } = useLocation();
  const [hasCheckedLogin, setHasCheckedLogin] = useState(false);

  useEffect(() => {
    (async function () {
      setRequestedPath(pathname, search);
      // Wait till the action is completed. Helps prevent calling login function in each reload.
      await checkLogin();
      setHasCheckedLogin(true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  if (!hasCheckedLogin) {
    return null;
  }

  if (!isAuthenticated) {
    return <Redirect to="/Login" />;
  }

  // The http effect is not immediate, so checking the local storage.
  if (!(hasAcceptedTC || getUserTcPreference(userId)))
    return (
      <AppLayout>
        <TermsAndConditions />
      </AppLayout>
    );
  return <Switch>{children}</Switch>;
};

PrivateRoutesWrapper.propTypes = {
  isAuthenticated: PropTypes.bool,
  hasAcceptedTC: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checkLogin: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default PrivateRoutesWrapper;
